import React, { useContext, useState } from 'react';
import { LoadTagCoWithComponent } from 'allianz-library';

import AppContext from '../../App/App.context';
import { RoundCheck } from '../../assets';
import logo from '../../assets/logo.png';
import sendFormValues from '../../api/form';
import Confirmation from '../Confirmation';
import ContactInformations from '../ContactInformations';
import ProductInformations from '../ProductInformations';

function useSteps() {
  const { currentMediaConfig, currentStep, setCurrentStep, setIsLoading } = useContext(AppContext);
  const [confirmationContent, setConfirmationContent] = useState(null);

  async function onSubmit(values) {
    setIsLoading(true);

    try {
      const result = await sendFormValues(values);

      setCurrentStep(currentStep + 1);
      setIsLoading(false);

      return setConfirmationContent(
        result.message.map(({ tagName, children, props }) => {
          const combinedProps = { ...props, key: Math.random() };

          if (tagName === 'RoundCheck') {
            return React.createElement(RoundCheck, combinedProps);
          }

          if (tagName === 'Logo') {
            return React.createElement('img', { ...combinedProps, src: logo, alt: 'logo' });
          }

          return React.createElement(tagName, combinedProps, children);
        })
      );
    } catch (error) {
      const errorMessage = (error && error.message) || 'Une erreur est survenue';

      return { error: errorMessage };
    }
  }

  const steps = [
    {
      name: 'Votre besoin',
      onValidate: onSubmit,
        
      render: () => (
        <>
          <ProductInformations />
          <ContactInformations />
        </>
      ),
    },
    {
      name: 'Confirmation',
      onValidate: () => {},
      render: () => <Confirmation>{confirmationContent}</Confirmation>,
    },
  ];

  return steps;
}

export default useSteps;
